export const getSelectedAnswer = (questionStatus, questionId) =>
  Object.values(questionStatus).filter(question => question?.questionId === questionId)[0]?.answer;
